{
  "Accessibility Menu": "Menu Aksesibilitas",
  "Reset settings": "Atur Ulang Pengaturan",
  "Close": "Tutup",
  "Content Adjustments": "Penyesuaian Konten",
  "Adjust Font Size": "Sesuaikan Ukuran Font",
  "Highlight Title": "Sorot Judul",
  "Highlight Links": "Sorot Tautan",
  "Readable Font": "Font Mudah Dibaca",
  "Color Adjustments": "Penyesuaian Warna",
  "Dark Contrast": "Kontras Gelap",
  "Light Contrast": "Kontras Terang",
  "High Contrast": "Kontras Tinggi",
  "High Saturation": "Saturasi Tinggi",
  "Low Saturation": "Saturasi Rendah",
  "Monochrome": "Monokrom",
  "Contrast": "Kontras",
  "Invert Colors": "Balikkan warna",
  "Tools": "Alat",
  "Reading Guide": "Panduan Membaca",
  "Stop Animations": "Hentikan Animasi",
  "Big Cursor": "Kursor Besar",
  "Increase Font Size": "Perbesar Ukuran Font",
  "Decrease Font Size": "Perkecil Ukuran Font",
  "Letter Spacing": "Jarak Huruf",
  "Line Height": "Tinggi Baris",
  "Font Weight": "Ketebalan Font",
  "Dyslexia Font": "Font Disleksia",
  "Language": "Bahasa",
  "Open Accessibility Menu": "Buka menu aksesibilitas",
  "Widget Settings": "Pengaturan widget",
  "Widget Position": "Posisi widget",
  "Top Left": "Kiri atas",
  "Top Center": "Tengah atas",
  "Top Right": "Kanan atas",
  "Center Left": "Tengah kiri",
  "Center Right": "Tengah kanan",
  "Bottom Left": "Kiri bawah",
  "Bottom Center": "Tengah bawah",
  "Bottom Right": "Kanan bawah",
  "Screen Reader": "Pembaca layar",
  "Voice Navigation": "Navigasi suara",
  "Custom Color": "Warna khusus",
  "Change the site's colors": "Ubah warna situs",
  "Backgrounds": "Latar belakang",
  "Headings": "Judul",
  "Contents": "Konten",
  "Reset colors": "Setel ulang warna",
  "Image Desaturation": "Pengurangan saturasi gambar",
  "Search languages": "Cari bahasa",
  "No languages found": "Tidak ada bahasa ditemukan",
  "Accessibility Profiles": "Profil aksesibilitas",
  "Motor Impaired": "Gangguan motorik",
  "Big cursor, voice navigation, and no animations.": "Kursor besar, navigasi suara, dan tanpa animasi.",
  "Blind": "Tunanetra",
  "Screen reader helpers with higher contrast.": "Bantuan pembaca layar dengan kontras lebih tinggi.",
  "Color Blind": "Buta warna",
  "High contrast palette with desaturated media.": "Palet kontras tinggi dengan media desaturasi.",
  "Dyslexia": "Disleksia",
  "Friendly font, extra spacing, stronger weight.": "Font mudah dibaca, jarak ekstra, dan bobot lebih tebal.",
  "Low vision": "Penglihatan rendah",
  "Dark contrast and 130% magnification.": "Kontras gelap dan pembesaran 130%.",
  "Cognitive & Learning": "Kognitif & pembelajaran",
  "Highlights key sections and enables voice help.": "Menyoroti bagian penting dan mengaktifkan bantuan suara.",
  "Seizure & Epileptic": "Kejang & epilepsi",
  "Stops animations and desaturates imagery.": "Menghentikan animasi dan mengurangi saturasi gambar.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Panduan membaca, tautan disorot, dan palet yang lebih tenang.",
  "Color Blindness": "Buta Warna",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Akromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulasi dan alat bantu bagi pengguna dengan defisiensi penglihatan warna.",
  "Widget Size": "Ukuran Widget",
  "Default": "Bawaan",
  "Medium": "Sedang",
  "Small": "Kecil"
}
